import { createStyles } from '@tf/ui';
import type React from 'react';

import { MarkdownText } from '@/components/shared/MarkdownText';

const useStyles = createStyles({
	markdown: {
		textAlign: 'center',

		'& h1, h2, h3, h4, h5': {
			fontWeight: 600,
			marginBottom: '12px',
			marginTop: '16px',
			lineHeight: '40px',
			fontSize: '32px',
		},

		'& p, ul, ol': {
			fontSize: '14px',
			fontWeight: '400',
			lineHeight: '20px',
			color: '#6B7280',
			margin: 0,
		},
	},
});

export const MarkdownPageIntro: React.FC<{ text: string }> = ({ text }) => {
	const { classes } = useStyles();

	return <MarkdownText className={classes.markdown} text={text} />;
};
